// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3739":"9b9eaefa","4660":"9b9eaefa","5362":"9b9eaefa","6821":"b74d9f2b","7371":"5605ec3f","9575":"9b9eaefa","9653":"af82f6af"}[chunkId] + ".chunk.css";
};